import { Trash2 } from 'lucide-react';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, biometricType, t }) => {
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-2xl p-6 max-w-md w-full mx-4">
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-red-100 rounded-full">
                        <Trash2 className="w-5 h-5 text-red-500" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900">
                        {t('Delete Biometric')}
                    </h3>
                </div>

                <p className="text-gray-600 mb-6">
                    {t(`Are you sure you want to delete your ${biometricType === 'FACE' ? 'face' : 'fingerprint'} biometric? You will need to set it up again to use it for login.`)}
                </p>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition-colors duration-200"
                    >
                        {t('Cancel')}
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg font-medium hover:bg-red-600 transition-colors duration-200"
                    >
                        {t('Delete')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmationModal;